module.exports = __webpack_public_path__ + "static/media/293535.71e1f2a2.png";